import React, { useState, useEffect } from "react";
import Map from "./Map";
import { Layers, TileLayer/*, VectorLayer*/ } from "./Layers";
import {
  osm,/*, vector*/

} from "./Source";
import { Controls, FullScreenControl, ZoomControl } from "./Controls";

import "./assets/css/App.css";
import "./assets/css/listeavis.css"
import { Grid } from "@mui/material";
import config from "./config";
import Accueil from "./composants/Accueil";
import Entete from "./composants/Entete";
import Cinemas from "./Layers/Cinemas";
import PointAdresse from "./Layers/PointAdresse";
import { useMatomo } from '@datapunt/matomo-tracker-react' 


const App = () => {

  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView({
      documentTitle: 'Cinémas', // optional
      href: document.location.href, // optional
    })
  }, [])

  const [center, setCenter] = useState(config.center);
  const [zoom] = useState(config.zoom);
  const [centreadresse, setCentreAdresse] = useState([0, 0]);
  const { enableLinkTracking } = useMatomo() 
  enableLinkTracking()
  return (
    <Grid direction="row" container className="interface">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={"entete_totale"}>
        <Accueil></Accueil>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="corps">

        <Grid container>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={9}>
            <Map center={center} zoom={zoom} setCenter={setCenter} setCentreAdresse={setCentreAdresse} className="carte">
              <Layers>
                <TileLayer source={osm()} zIndex={0} />
                <Cinemas zIndex={10} />
                <PointAdresse centreadresse={centreadresse} />
              </Layers>
              <Controls>
                <FullScreenControl />
                <ZoomControl />
              </Controls>
            </Map>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={3} xl={3} className="accueil_page_droite">
            <Entete />
          </Grid>
        </Grid>
        
      </Grid>
    </Grid >
  );
};

export default App;
